export const terms = {
  "header": {
    "badge": "Legal information",
    "title": "Terms of Use"
  },
  "content": {
    "intro": "Welcome to DONKEY TRAVEL. These conditions of use govern access and use of our housing exchange platform. By using our services, you accept these terms in full.",
    "eligibility": {
      "title": "1. Eligibility and Registration",
      "text": "Access to the DONKEY TRAVEL club is strictly reserved for hosts with an active ad on recognized platforms (such as Airbnb) with a minimum overall rating of 4.5 out of 5. Any falsification of these criteria will result in the immediate deletion of the account without refund of the subscription."
    },
    "subscription": {
      "title": "2. Subscription and Payments",
      "text": "Full use of the platform requires subscribing to one of our packages (Monthly, Annual or Club+). Payments are secure and processed by third-party providers. The subscription is tacitly renewable unless canceled by the user."
    },
    "exchanges": {
      "title": "3. How exchanges work",
      "text": "Exchanges within the club are based on trust and mutual respect. Exchange agreements are made directly between members via our internal messaging. A moral and, where applicable, legal exchange contract is concluded between the two parties."
    },
    "responsibilities": {
      "title": "4. Commitments and Responsibilities",
      "text": "Each member undertakes to present their accommodation in a transparent manner, with recent photos and accurate descriptions. The host member ensures the impeccable hygiene of the place. The visiting member undertakes to scrupulously respect the accommodation and its internal regulations. DONKEY TRAVEL acts as a facilitator and is not a party to the exchange contracts between members. We assume no responsibility for damages, disputes or last minute cancellations, although we can intervene in mediation."
    },
    "termination": {
      "title": "5. Suspension and Termination",
      "text": "DONKEY TRAVEL reserves the right to suspend or ban any member who does not respect the rules of good conduct of the community, accumulates bad feedback, or violates these conditions, unilaterally."
    },
    "contact": {
      "title": "6. Applicable law and disputes",
      "text": "These conditions are governed by French law. In the event of disagreement, the parties undertake to seek an amicable solution before any legal action before the competent courts. For any questions, contact us at legal@donkey.travel."
    }
  }
};
